<template>
  <v-container>
    <v-row justify="center">
      <v-col lg="8">
        <VirveMessageWidget :isLoading="isLoading" />
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="sass" scoped></style>
<script>
// @ is an alias to /src
import VirveMessageWidget from "@/components/VirveMessageWidget.vue";

export default {
  name: "AlertComponent",
  components: {
    VirveMessageWidget
  },
  data: () => ({
    isLoading: false
  }),
  async mounted() {}
};
</script>
